import { Info } from 'lucide-react'
import { Popover, PopoverTrigger, PopoverContent } from './ui/popover'
import { orderStatusInfo } from '../config/orderStatuses'

/** An (i) beside an order status that explains it. Renders nothing for a status with no explanation. */
export default function OrderStatusInfo({ status }) {
  const text = orderStatusInfo(status)
  if (!text) return null
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`What ${status} means`} onClick={e => e.stopPropagation()}
          className="inline-flex align-middle text-muted-foreground hover:text-foreground">
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-3 text-xs font-normal normal-case" onClick={e => e.stopPropagation()}>
        <p className="mb-1 font-mono text-[11px] text-muted-foreground">{status}</p>
        {text}
      </PopoverContent>
    </Popover>
  )
}
